import Vue from 'vue';
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import ABaseComponent from "Components/Base/ABaseComponent";
import { State } from "vuex-class";
import productList from 'Store/productList/productList';
import { FilterItem } from 'Models/FacetFilter/FilterItem';

@Component({})
export class FacetFilterButtonComponent extends ABaseComponent {

    addFilter(key:string,value:string) {
        let filterArray:FilterItem[] = new Array();
        filterArray.push(new FilterItem(key,value));
        productList.dispatchUpdateQuery(filterArray);
    }
}
Vue.component("facet-filter-button", FacetFilterButtonComponent)